import seq from '@Helpers/seq'
import { action, computed, observable } from 'mobx'
import { BaseStore, getOrCreateStore } from '../../di'
import { MANUAL } from './constants'

// OBSOLETED BY useAddAlert() hook and the underlying alertAtom Recoil atom. TODO: Remove this store.

export const Alert = ({ message, dismiss, type }) => {
  return {
    id: `alert-${seq()}`,
    message,
    dismiss,
    type,
  }
}

class AlertStore extends BaseStore {
  @observable alerts = []
  _timer = 0
  opts = {
    duration: 5000,
  }

  @computed
  get empty() {
    return this.alerts.length === 0
  }

  @action
  show = (message, type, dismiss) => {
    const alert = Alert({ message, type, dismiss })
    this.alerts.push(alert)
    this._queueDismissAll()
  }

  @action
  dismiss = (id) => {
    const alert = this.alerts.find((a) => a.id === id)
    this.alerts.remove(alert)
  }

  @action
  dismissAll() {
    this.alerts.replace(this.alerts.slice().filter((a) => a.dismiss === MANUAL))
  }

  @action
  dismissAllManualAlerts() {
    this.alerts = []
  }

  _queueDismissAll() {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.dismissAll(), this.opts.duration)
  }
}

export default getOrCreateStore('AlertStore', AlertStore)
